import {
	FormCheckbox as FormCheckboxDS,
	type FormCheckboxProps as FormCheckboxPropsDS,
} from '@gov-design-system-ce/react-form';
import { MessageWrapper } from './MessageWrapper';

type FormCheckboxProps = Omit<
	FormCheckboxPropsDS,
	'messageWrapper' | 'classNames'
>;

export const FormCheckbox = (props: FormCheckboxProps) => (
	<FormCheckboxDS
		{...props}
		field={{ size: 'm', ...props.field }}
		messages={props.messages ?? { messages: [] }}
		messageWrapper={MessageWrapper}
	/>
);
